const DRIVERS_URL = '/driver';

export const sendPasswordEmailToDriver = (driverId) => {
  const url = `${DRIVERS_URL}/reset-password/${driverId}`;
  return url;
};

export const getAllDrivers = () => `${DRIVERS_URL}/all`;
